export default class RoomType {
  constructor() {
    this.id = null;
    this.name = null;
    this.icon = "mdi-floor-plan";
    this.contentTypes = { 'options': [] };
    this.stateQuestions = {
      'questions': [
        {
          'id': 'floor',
          'title': 'Gulv og lister',
          'active': true,
          'value': -1
        },
        {
          'id': 'doors',
          'title': 'Dører',
          'active': true,
          'value': -1
        },
        {
          'id': 'walls',
          'title': 'Vegger',
          'active': true,
          'value': -1
        },
        {
          'id': 'ceiling',
          'title': 'Tak',
          'active': true,
          'value': -1
        },
        {
          'id': 'outlets',
          'title': 'Stikkontakter og lysbrytere',
          'active': true,
          'value': -1
        },
        {
          'id': 'inventory_included',
          'title': 'Inventar følger med boligen',
          'active': true,
          'value': -1
        }
      ]
    };
    this.cleanQuestions = {
      'questions': [
        {
          'id': 'ceiling',
          'title': 'Tak',
          'active': true,
          'value': -1
        },
        {
          'id': 'walls',
          'title': 'Vegger',
          'active': true,
          'value': -1
        },
        {
          'id': 'floor',
          'title': 'Gulv',
          'active': true,
          'value': -1
        },
        {
          'id': 'doors',
          'title': 'Dører',
          'active': true,
          'value': -1
        },
        {
          'id': 'windows',
          'title': 'Vinduer',
          'active': true,
          'value': -1
        },
        {
          'id': 'trim',
          'title': 'Karmer/lister',
          'active': true,
          'value': -1
        }
      ]
    };
    this.wallTypes = {
      'options': [
        {
          'id': 'painted',
          'title': 'Malte vegger'
        },
        {
          'id': 'tiles',
          'title': 'Fliser'
        },
        {
          'id': 'panel',
          'title': 'Panel'
        },
        {
          'id': 'painted_panel',
          'title': 'Malt panel'
        },
        {
          'id': 'wallpaper',
          'title': 'Tapet'
        },
      ]
    };
    this.floorTypes = {
      'options': [
        {
          'id': 'parquet',
          'title': 'Parkett'
        },
        {
          'id': 'laminate',
          'title': 'Laminat'
        },
        {
          'id': 'wood',
          'title': 'Tregulv'
        },
        {
          'id': 'tiles',
          'title': 'Fliser'
        },
        {
          'id': 'linoleum',
          'title': 'Linoleum'
        },
        {
          'id': 'carpet',
          'title': 'Teppe'
        },
      ]
    };
    this.ceilingTypes = {
      'options': [
        {
          'id': 'panel',
          'title': 'Panel'
        },
        {
          'id': 'plaster',
          'title': 'Gips'
        },
        {
          'id': 'painted',
          'title': 'Malt himling'
        },
        {
          'id': 'ace',
          'title': 'Tak-ess'
        },
      ]
    };
    this.lightingTypes = {
      'options': [
        {
          'id': 'downlights',
          'title': 'Downlights'
        },
        {
          'id': 'tube',
          'title': 'Lysstoffrør'
        },
        {
          'id': 'ceiling_light',
          'title': 'Taklampe'
        },
        {
          'id': 'wall_light',
          'title': 'Vegglampe'
        },
        {
          'id': 'table_light',
          'title': 'Bordlampe'
        },
        {
          'id': 'strip',
          'title': 'Lysskinne / Led-stripe'
        },
        {
          'id': 'spot',
          'title': 'Spotlys'
        },
      ]
    };
    this.heatingTypes = {
      'options': [
        {
          'id': 'cables',
          'title': 'Varmekabler'
        },
        {
          'id': 'panel',
          'title': 'Panelovn'
        },
        {
          'id': 'wood',
          'title': 'Vedovn'
        },
        {
          'id': 'fireplace',
          'title': 'Peis'
        },
        {
          'id': 'oil',
          'title': 'Oljefyring'
        },
        {
          'id': 'water',
          'title': 'Radiator'
        },
        {
          'id': 'infra',
          'title': 'Infrarød'
        },
        {
          'id': 'gas',
          'title': 'Gass'
        },
      ]
    };
  }
}
